import { Modal, Row, Col } from "antd";
import Toolbar from "components/Toolbar/index";
import { Flex, Box, Text } from "@chakra-ui/react";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FooterModal from "components/Button/FooterModal";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import { TipoEntidadeEnum } from "resources/enums/conta";
import { useState, useEffect } from "react";
import { FiltroCobranca } from "core/features/cobranca/typings";
import SelectContaBancaria from "ui/components/Input/SelectContaBancaria";
import { defaultValuesFiltroCobranca } from "../../hooks/useFiltroCobrança";
import SelectUnidade from "ui/components/Input/SelectUnidade";

interface ModalFiltrosCobrancaProps {
  open: boolean;
  onClose: () => any;
  onChangeFiltro: (v: Partial<FiltroCobranca>) => void;
  filtro: FiltroCobranca;
  onReset: () => void;
  tenantId: string;
}

export default function ModalFiltrosCobranca({
  filtro,
  onChangeFiltro,
  onClose,
  onReset,
  open,
  tenantId,
}: ModalFiltrosCobrancaProps) {
  const [localFiltro, setLocalFiltro] = useState<FiltroCobranca>(filtro);

  useEffect(() => {
    if (!open) {
      setLocalFiltro(filtro);
    }
  }, [open, filtro]);

  const numFiltros =
    (localFiltro.contasBancariasIds?.length ? 1 : 0) +
    (localFiltro.pessoasIds?.length ? 1 : 0) +
    (localFiltro.tipoContatoAcordo ? 1 : 0) +
    (localFiltro.unidadesIds ? 1 : 0);

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      closable={false}
      destroyOnClose
      className="antd-custom-header"
      width="700px"
      title={<Toolbar title="Filtrar" onClose={onClose} border="0px" />}
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onClose();
            }}
            onClose={() => {
              onReset();
              setLocalFiltro(defaultValuesFiltroCobranca);
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            filtroValue={numFiltros}
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
          />
        </Flex>
      }
    >
      <Box as={Row} mb={4} gutter={24}>
        <Col md={24}>
          <Text mb="2px" fontSize="13px">
            Pessoa
          </Text>
          <SelectPessoas
            mode="multiple"
            tipoEntidades={[TipoEntidadeEnum.Condomino]}
            value={localFiltro.pessoasIds}
            placeholder="Pesquise por CPF/CNPJ, Nome do morador, unidade..."
            onChange={(pessoasIds) => {
              setLocalFiltro((state) => ({ ...state, pessoasIds }));
            }}
          />
        </Col>
      </Box>
      <Box as={Row} mb={4} gutter={24}>
        <Col md={24}>
          <Text mb="2px" fontSize="13px">
            Unidades
          </Text>
          <SelectUnidade
            mode="multiple"
            tenantId={tenantId}
            onChange={(unidadesIds) => {
              setLocalFiltro((state) => ({
                ...state,
                unidadesIds,
              }));
            }}
            value={localFiltro.unidadesIds}
          />
        </Col>
      </Box>
      <Box as={Row}>
        <Text mb="2px" fontSize="13px">
          Conta bancária
        </Text>
        <SelectContaBancaria
          value={localFiltro.contasBancariasIds}
          mode="multiple"
          onChange={(contasBancariasIds) => {
            setLocalFiltro((state) => ({ ...state, contasBancariasIds }));
          }}
        />
      </Box>
    </Modal>
  );
}
